import Users from '../components/Users';
import MainLayout from '../layout/MainLayout';

const UsersPage = () => {
	return (
		<MainLayout title="Users">
			<Users />
		</MainLayout>
	);
};

export default UsersPage;
